import React from 'react';
import FilterTable from './filterTable';

import './common.css';
import FavoriteItemColumnFormatter from './favoriteItemColumnFormatter';
import extractSearchParams from '../common/extractSearchParams';

const NotActivated = "Not activated";

const TemporaryLicenseTable = props  => {
  let productNameFilterValues = { 'all': '' };
  props.products.forEach(product => productNameFilterValues[product.name] = product.name);

  const obtainingMethodFilterValues = { all: '', purchased: 'purchased', free: 'free' };

  const columns = [{
    dataField: 'key',
    text: 'License key',
    sort: true,
    defaultValue: extractSearchParams(props.requestData.location.search, 'license.key'),
    filter_: { type: 'text' },
    headerStyle: () => ({width: '15em'})
  }, {
    dataField: 'generationDateTime',
    text: 'Generation date and time',
    sort: true,
    filter_: {type: 'datetime'},
    headerStyle: () => ({width: '11em'})
  }, {
    dataField: 'productName',
    text: 'Product name',
    sort: true,
    filter_: {
      type: 'select',
      values: productNameFilterValues
    },
    headerStyle: () => ({width: '7em'})
  }, {
    dataField: 'obtainingMethod',
    text: 'Obtaining Method',
    sort: true,
    filter_: {
      type: 'select',
      values: obtainingMethodFilterValues
    },
    headerStyle: () => ({width: '7em'})
  },
  {
    dataField: 'featuresStr',
    text: 'Features',
    filter_: { type: 'text' },
    headerStyle: () => ({width: '7em'})
  }, {
    dataField: 'activationDateTime',
    text: 'Activation date and time',
    sort: true,
    filter_: {type: 'datetime'},
    headerStyle: () => ({width: '11em'})
  }, {
    dataField: 'deviceKey',
    text: 'Device key',
    sort: true,
    filter_: { type: 'text' },
    headerStyle: () => ({width: '12em'})
  }, {
    dataField: 'expirationDateTime',
    text: 'Expiration date and time',
    sort: true,
    filter_: {type: 'datetime'},
    headerStyle: () => ({width: '11em'})
  }, {
    dataField: 'client.fullName',
    text: 'Client',
    filter_: {
      type: 'text',
      searchable: true,
    },
    sort: true,
  }, {
    dataField: 'isFavorite',
    text: 'Favorite',
    sort: false,
    align: 'center',
    filter_: {
      type: 'select',
      values: {
        'all': '',
        'favorite': 'true',
      },
    },
    headerStyle: () => ({width: '35px'}),
    formatter: (cell, row) => <FavoriteItemColumnFormatter
      cell={cell} row={row}
      actions={props.actions}/>,
  }];

  const defaultSorted = [{
    dataField: 'generationDateTime',
    order: 'desc'
  }];

  let temporaryLicenses = props.temporaryLicenses.map(element => {
    let rElem = {...element};
    rElem.deviceKey = null;
    if (rElem.device !== null) {
      rElem.deviceKey = rElem.device.key;
    }
    if ((rElem.activationDateTime === null) && (rElem.deviceKey === null)) {
      rElem.deviceKey = NotActivated;
      rElem.activationDateTime = NotActivated;
    }
    rElem.featuresStr = rElem.features === null ? null :
      rElem.features.map(feature => feature.name + (feature.expirationDate !== null ? ` [${feature.expirationDate}]` : '')).join(', ');
    return rElem;
  });

  return (
    <FilterTable
      {...props}
      objectName={'temporaryLicenses'}
      data={temporaryLicenses}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no temporary licenses"
    />
  );
};

export default TemporaryLicenseTable;



// WEBPACK FOOTER //
// ./src/components/temporaryLicenseTable.js